function Header() {
  return (
    <header className="header">
      <div className="container">
        <h1 className="name">Makoto Moses Kumasaka</h1>
        <p className="tagline">A designer and developer based in the San Fransisco Bay Area.</p>
      </div>
    </header>
  )
}

export default Header

